import axios from "axios";

export const getSection3 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/testimonial-page-s3-comment?populate[Comments][populate]=*&populate[Featured][populate]=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
